import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description TailArrowLeft icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { TailArrowLeft } from '@sravni/design-system-icons'
 *
 * <TailArrowLeft />
 * ```
 */
var TailArrowLeft = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "TailArrowLeft", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m9 5-5 5 5 5M5 10h11", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { TailArrowLeft };
//# sourceMappingURL=TailArrowLeft.js.map
